import Service from "../Service";

const resource = "ExtReportCustomer/";

export default {
  list(params, requestID) {
    return Service.post(resource + "list", params, {
      params: { requestID },
    });
  },
  listWeek(params, requestID) {
    return Service.post(resource + "listWeek", params, {
      params: { requestID },
    });
  },
  excel(params, requestID) {
    return Service.post(resource + "excel", params, {
      params: { requestID },
      responseType: "blob",
    });
  },
  testConnection(params, requestID) {
    return Service.post(resource + "testConnection", params, {
      params: { requestID },
    });
  },
};
